import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import {isAuthenticated, getAvailableModels, getModels, isModelCacheLoaded, isModelCacheLoading} from "~/stateGetter";
import {areAllModelsReady, isAnyModelLoading} from "~/statePresenter";
import {fetchModelConfigs} from "~/rx/modelConfigs";
import limit from "~/data/limit";
import identify from "~/identify";
//import get from 'lodash/get';
//import cn from 'classnames';
//import css from './css.css';

export class ModelConfigCache extends Component {
	static propTypes = {

	};
	
    loadModelConfigsIfOutOfSync() {
		if(!this.props.shouldLoad) {
			return;
		}

		return this.props.fetchModelConfigs(this.props.availableModels);
	}
	
    componentDidUpdate() {
    	this.loadModelConfigsIfOutOfSync();
    }

    componentDidMount() {
        this.loadModelConfigsIfOutOfSync();
    }

	render() {
		return null;
	}
}

const RXModConfigCache = connect(
    (state) =>  {
        return {
			isLoading: isModelCacheLoading(state),
			isLoaded: isModelCacheLoaded(state),
			availableModels: getAvailableModels(state),
			isAuthenticated: isAuthenticated(state),
        }    
    },
    (dispatch, { modelId }) => {
        return {
            fetchModelConfigs: (modelNames) => dispatch(fetchModelConfigs(modelNames, {isForCache:true}))
        }
    },

	({isAuthenticated,isLoading,isLoaded, availableModels}, dispatchers) => {
    	let commonProps = {
            availableModels,
            ...dispatchers
		};

    	return {
    		shouldLoad: isAuthenticated && !isLoading && !isLoaded,
            ...commonProps
		}
	}
)(ModelConfigCache);

export default RXModConfigCache;